import styled from '@emotion/styled';
import { Image } from 'antd';
import { FC, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Bread } from '../../common/component/Bread';
import { ImageFill } from '../../common/component/ImageFill';
import { FileLine } from '../../module/files/components/FileLine';
import { ProductEntity } from '../../module/product/entity/product.entity';
import { getProductDetail } from '../../module/product/service/product.service';

export const ProductDetail: FC = () => {
	const [info, setInfo] = useState<ProductEntity>({});

	const { id } = useParams();

	const init = useCallback(async () => {
		if (id) {
			const { data } = await getProductDetail(Number(id));
			setInfo(data);
		}
	}, [id]);

	useEffect(() => {
		window.scrollTo(0, 0);
		init();
	}, [init]);

	const breadArr = [
		{
			title: '产品相关',
			link: '/products',
		},
		{
			title: info.title,
		},
	];

	return (
		<Container>
			<ImageFill src={info.image ?? ''} width={1600} height={500} areaHeight={296} />
			<div className='content'>
				<div className='page-title'>
					<h1>{info.title ?? ''}</h1>
				</div>
				<Bread value={breadArr} />
				<div style={{ padding: '1rem' }}>
					<h3 dangerouslySetInnerHTML={{ __html: info.description ?? '' }} />
					<div className='description'>
						<div className='left col-lg-7 col-md-7 col-xs-12'>
							<Image src={info.image} width='100%' preview={false} />
							<br />
							<br />
							<div dangerouslySetInnerHTML={{ __html: info.content ?? '' }} />
						</div>
						<div className='right col-lg-4 col-md-4 col-xs-12' dangerouslySetInnerHTML={{ __html: info.section ?? '' }} />
					</div>
				</div>
			</div>
			<div className='exterinor-content'>
				<div className='content'>
					{info.tagTitle && <h2>{info.tagTitle}</h2>}
					{info.tagContent && (
						<div className='tag-list'>
							{info.tagContent.split(',').map((item, index) => {
								return (
									<div className='tag col-lg-3 col-md-4 col-xs-12' key={index}>
										<div>{item}</div>
									</div>
								);
							})}
						</div>
					)}
					{info.downloads && (
						<div style={{ marginTop: '2rem' }}>
							<h2>下载中心</h2>
							{info.downloadsArr &&
								info.downloadsArr.map((item, index) => {
									return <FileLine value={item} key={index} />;
								})}
						</div>
					)}
					{info.dataSheets && (
						<div style={{ marginTop: '2rem' }}>
							<h2>数据表格下载</h2>
							{info.dataSheetsArr &&
								info.dataSheetsArr.map((item, index) => {
									return <FileLine value={item} key={index} />;
								})}
						</div>
					)}
				</div>
			</div>
		</Container>
	);
};
const Container = styled.div`
	width: 100%;

	.content {
		background: white;
		z-index: 10;
		position: relative;

		.description {
			display: flex;
			justify-content: space-between;

			.right {
				table,
				table tr th,
				table tr td {
					border: 1px solid #ccc;
					border-collapse: collapse;
					padding: 0.75rem;
				}

				table {
					th {
						background-color: #004885;
						color: #fff;
						line-height: 2rem;
					}
				}
			}
		}
	}

	.exterinor-content {
		background-color: #fff;

		.content {
			margin-top: 0;
			padding-top: 0;

			.tag-list {
				display: flex;
				justify-content: left;
				flex-wrap: wrap;
				margin: 0 -1rem;

				.tag {
					padding: 0.2rem 1rem;
					div {
						display: block;
						background-color: #004885;
						padding: 1rem;
						color: #fff;
						line-height: 1rem;
						height: 5rem;
					}
				}
			}
		}
	}
`;
